import _ from "lodash";
import { Account } from "types";
import { ValueOf } from "global";
import { VendorOpportunity } from "modules/vendorOpportunity";
import { CcEmailOptionGroups, FinanceProgramFormValues } from "modules/desking/types";

export function getCcEmailOptions(
  vo: VendorOpportunity,
  creditAppData: any,
  accountContacts: Account["contacts"]
): ValueOf<FinanceProgramFormValues, "ccEmail"> {
  const customerContacts = _([
    creditAppData?.primaryContact,
    ...(creditAppData?.creditApplicationOwner ?? []),
    ...(creditAppData?.creditApplicationContacts ?? []),
  ])
    .filter((contact: any) => !!contact?.email)
    .uniqBy("ownerPgId")
    .map((contact: any) => ({
      email: contact.email,
      title: contact.title,
      fullName: `${contact.firstName} ${contact.lastName}`,
      group: CcEmailOptionGroups.CustomerContacts,
    }))
    .value();

  const voContacts = [vo?.salesRepresentative, vo?.salesManager, vo?.financeManager]
    .filter((contact: any) => !!contact?.email && contact.status !== "blocked")
    .map((contact: any) => ({
      email: contact.email,
      title: contact.title,
      fullName: `${contact.firstName} ${contact.lastName}`,
      group: CcEmailOptionGroups.DealershipContacts,
    }));

  const voContactsEmails = voContacts.map((contact: any) => contact.email);

  const otherContacts = accountContacts
    .filter(
      (contact: any) =>
        !!contact.email && !voContactsEmails.some(email => contact.email === email) && contact.status !== "blocked"
    )
    .map((contact: any) => ({
      email: contact.email,
      title: contact.title,
      fullName: contact.fullName,
      group: CcEmailOptionGroups.OtherContacts,
    }));

  return [...customerContacts, ...voContacts, ...otherContacts];
}
